// #region CONSTANTES
// Types de paiement
export const FREE = "Free";
export const PAYZEN = 2;
export const PAYZEN_TPE = 3;
export const PAYZEN_BORNE = 4;
export const TPE = "TPE";

export const MODES = {
  PARENT: 0,
  ENFANT: 1,
  TOTAL: 2
};

export const SERVICES_NAMES = {
  ACCES: "ACC",
  EAU_VIDANGE: "EAU",
  ELECTRICICTE: "ELE",
  PARKING: "PAR",
  PRISE: "PRI",
  ROB: "ROB",
  STATIONNEMENT: "STA",
  TAXE: "TAX",
};

export const SERVICES_TYPES = {
  EAU_VIDANGE: 1,
  ELECTRICICTE: 2,
  A32: 3,
  PARKING: 4,
  EAU_VIDANGE2: 5,
  PRISE_REHARGE: 6,
  A16: 7,
  EAU_ELEC: 8,
  ACCES_TEMPORAIRE: 9,
  TAXE_SEJOUR: 10,
  A63: 11,
  STATIONNEMENT_DEMONSTRATEUR: 99,
  TEST: 100
};

export const UNITE_TYPES = {
  PARKING: 4,
  PERSONNE_24H: 12,
  EMPLACEMENT_24H: 13
};

export const UNITE_FAMILLE = {
  TEMPS: "temps",
  VOLUME: "volume"
};

export const TARIF_TYPE = {
  TEMPS: "1",
  VOLUME: "2",
};

export const TYPE_ACHAT = {
  TEST: "TEST",
  PROD: "PROD",
  INCONNU: "INCONNU"
};
// #endregion
